import React, { useState, useEffect } from 'react';
import style from '../css/HeaderTaller.module.css';
import '../css/HeaderTaller.css';

import VideoModal from './modals/VideoModal';

import ReactPlayer from 'react-player';
import libel from '../images/logo2.png';

import whatsapp from '../images/whatsapp.png';
import calendario from '../images/calendario.png';
import play from '../images/play.png';
import { BsArrowRight } from 'react-icons/bs';

const Header = () => {
	const [openModal, setOpenModal] = useState(false);
	const [url, setUrl] = useState(false);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const handlerClose = () => {
		setOpenModal(false);
	};

	const handlerOpen = () => {
		if (windowWidth <= 500) setUrl('https://www.youtube.com/watch?v=5YGychOCnRU');
		if (windowWidth > 500) setUrl('https://www.youtube.com/watch?v=5YGychOCnRU');

		setOpenModal(true);
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<section className={style.mainSection}>
			<VideoModal vertical={false} modal={openModal} url={url} handlerClose={handlerClose} />

			<div className={style.mainContainer}>
				<div className={style.cicleBackground}></div>
				<div className={style.titleContainer}>
					<img style={{ maxWidth: '80px', marginBottom: '12px' }} src={libel} alt='logo' />

					<div className={style.titleTopContainer}>
						<div className={style.line}></div>
						<h3>Online en vivo</h3>
						<div className={style.line}></div>
					</div>
					{/* <h2> Chía - Cundinamarca</h2> */}

					<h1>
						Escultura en ZBRUSH <br />
						<span>
							{' '}
							<b>para impresión 3D</b>{' '}
							{/* <img
								src='https://writebot-html.themetags.net/assets/img/text-underline-1.svg'
								alt='line'
							/> */}
						</span>
					</h1>

					<div className={style.titleTopContainer} style={{ marginTop: '12px' }}>
						<div className={style.line}></div>
						<h3>Certificación Universitaria</h3>
						<div className={style.line}></div>
					</div>

					{/* <p>
						Vive la experiencia de un taller en vivo y lleva tu arte al siguiente nivel.
						<br />
						Dibuja en 2D, modela en Blender e integra IA en tu creación.
					</p> */}
					{/* <div className={style.buttonsContainer}>
						<a
							className={style.button1}
							href='#plans'
							// target='blank_'
						>
							<span>Regístrate Ahora</span>
							<BsArrowRight />
						</a>

						<a
							className={style.button1}
							style={{ width: '250px' }}
							href='https://drive.google.com/file/d/1LQQanW0hE7Wo_FCZsfxClZWel9H2bQ9A/view?usp=sharing'
							// target='blank_'
						>
							<span>Descargar Programación</span>
							<BsArrowRight />
						</a>
					</div> */}
				</div>

				<div className={style.imgContainer}>
					{/* <div className={style.playButton} onClick={handlerOpen}>
						<img src={play} alt='play' />
					</div> */}

					<ReactPlayer
						className='player'
						url='https://www.youtube.com/watch?v=46I8EI8-On0'
						playing={true}
						controls={true}
						volume={0}
						width='100%'
						height='100%'
						playsinline
					/>
					{/* <div className='player-wrapper'>
						<ReactPlayer
							className='player2'
							url='https://vimeo.com/1012409489'
							playing={true}
							controls={true}
							volume={0}
							width='100%'
							height='100%'
							playsinline
						/>
					</div> */}
				</div>

				{/* <div className={style.buttonsContainer} style={{ marginBottom: '12px' }}>
					<a
						className={style.button1}
						href='https://calendly.com/d/cmnr-68p-fsw/asesoria-en-formacion-para-especialistas-3d'
						// target='blank_'
					>
						Reserva tu cita
						<BsArrowRight />
					</a>
				</div> */}
			</div>
			<svg width='0' height='0'>
				<filter id='grainy' x='0' y='0' width='100%' height='100%'>
					<feTurbulence type='fractalNoise' baseFrequency='.537'></feTurbulence>
					<feColorMatrix type='saturate' values='0'></feColorMatrix>
					<feBlend mode='multiply' in='SourceGraphic' in2='floodFill'></feBlend>
				</filter>
			</svg>
		</section>
	);
};

export default Header;
